import { hpostRequest, hgetRequest } from '@u/htools.axios.js';

/*
 *@Description: 故障原因列表
 *@MethodAuthor:  zxh
 *@Date: 2026-01-26 09:56:54   ProblemProcess
 */
export const listService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				pageNum: 1,
				pageSize: 10,
				name: '',
				...data
			};

			const page = dataJson.pageNum;
			const pagesize = dataJson.pageSize;
			delete dataJson.pageNum;
			delete dataJson.pageSize;
			const res = await hpostRequest(`hlzlong/process/search?page=${page}&pagesize=${pagesize}`, dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};

/*
 *@Description: 故障原因列表（所有）
 *@MethodAuthor:  zxh
 *@Date: 2026-01-26 09:56:54   ProblemProcess
 */
export const ProblemProcessAllListService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hgetRequest('hlzlong/process/all', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障原因添加
 *@MethodAuthor:  zxh
 *@Date: 2026-01-26 10:00:29
 */
export const addService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				name: '',
				...data
			};
			const res = await hpostRequest('hlzlong/process/add', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障原因编辑
 *@MethodAuthor:  zxh
 *@Date: 2026-01-26 10:12:58
 */
export const editService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				id: '',
				name: 0,
				...data
			};
			const res = await hpostRequest('hlzlong/process/update', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障原因详情
 *@MethodAuthor:  zxh
 *@Date: 2026-01-26 09:59:21
 */
export const detailService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				id: '',
				...data
			};
			const res = await hgetRequest('hlzlong/process/get1', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 故障原因删除
 *@MethodAuthor:  zxh
 *@Date: 2026-01-26 10:12:03
 */
export const deleteService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = [...data];
			const res = await hpostRequest('hlzlong/process/deletes', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};

export default listService;
